///// FILTER

// Saved filters are wiped after 24 hours without using the system
// (see clearIfInactive / the activity tracking at the bottom of this file).
const LAST_ACTIVE_KEY = "last_active_at";
const INACTIVITY_LIMIT_MS = 24 * 60 * 60 * 1000;

// localStorage turns a Date into "Tue Sep 01 2026 00:00:00 GMT+0800 (...)",
// which the backend's moment can't parse reliably. Store dates as local
// "YYYY-MM-DDTHH:mm:ss" instead (not toISOString - UTC would shift PH
// midnight to the previous day). Strings already in YYYY-MM-DD form pass as-is.
const toStoredDate = (value) => {
  if (!value) return value;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value;
  }
  const d = new Date(value);
  if (isNaN(d)) return value;
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
};

const FilterStore = {
  // ------- Inactivity reset -------
  // Records "the user is using the system now".
  touchActivity() {
    localStorage.setItem(LAST_ACTIVE_KEY, String(Date.now()));
  },

  // Clears the saved filters when the last activity is more than 24 hours
  // ago. Uses clear() below, so the theme and the login token are kept.
  clearIfInactive() {
    const lastActive = Number(localStorage.getItem(LAST_ACTIVE_KEY));
    if (lastActive && Date.now() - lastActive > INACTIVITY_LIMIT_MS) {
      this.clear();
    }
  },

  // ------- Theme (dark / light) -------
  // Same key ("theme") the app already used, so a saved choice keeps working.
  // NOTE: clear() below must never remove this key - the theme should survive
  // logout and filter resets.
  saveTheme(theme) {
    localStorage.setItem("theme", theme === "dark" ? "dark" : "light");
  },
  getTheme() {
    return localStorage.getItem("theme") === "dark" ? "dark" : "light"; // default: light
  },

  // ------- For Date Range -------
  save(from, to) {
    if (from) {
      localStorage.setItem("filter_from", toStoredDate(from));
    } else {
      localStorage.removeItem("filter_from");
    }

    if (to) {
      localStorage.setItem("filter_to", toStoredDate(to));
    } else {
      localStorage.removeItem("filter_to");
    }
  },

  get() {
    const from = localStorage.getItem("filter_from");
    const to = localStorage.getItem("filter_to");

    if (from && to) {
      // toStoredDate also upgrades values saved before this fix
      return { id: "custom", from: toStoredDate(from), to: toStoredDate(to) };
    }
    return null;
  },

  // --- Account List 1 - Date Range ---
  AL1saveDate(from, to) {
    if (from) {
      localStorage.setItem("filter_from_accountlist1", from);
    } else {
      localStorage.removeItem("filter_from_accountlist1");
    }
    if (to) {
      localStorage.setItem("filter_to_accountlist1", to);
    } else {
      localStorage.removeItem("filter_to_accountlist1");
    }
  },
  AL1getDate() {
    const from = localStorage.getItem("filter_from_accountlist1");
    const to = localStorage.getItem("filter_to_accountlist1");
    if (from && to) return { from, to };
    return null;
  },
  //-----------------------------------------------------

  // Tab for approve and pending
  saveTab(tabKey) {
    localStorage.setItem("active_tab", tabKey);
  },

  getTab() {
    return localStorage.getItem("active_tab") || "pending"; // Default to "pending"
  },

  // --- get and save Customer ---
  saveSelected(SelectedId) {
    // Guard: only save if it's a valid array — never save a single object
    // which would cause backend selectedCustomer.map() to crash
    if (Array.isArray(SelectedId)) {
      localStorage.setItem("Selected_id", JSON.stringify(SelectedId));
    }
  },
  getSelected() {
    try {
      const saved = localStorage.getItem("Selected_id");
      if (!saved) return []; // CHANGED: was null, now [] so MultiSelect always receives a valid array
      const parsed = JSON.parse(saved);
      // CHANGED: was null, now [] so backend .map() and MultiSelect never receive null
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return null;
    }
  },

  // --- get and save Status ---
  saveStatus(status) {
    localStorage.setItem("selected_status", status);
  },
  getStatus() {
    return localStorage.getItem("selected_status") || "Active";
  },

  // --- get and save Type ---
  saveType(type) {
    localStorage.setItem("selected_type", type);
  },
  getType() {
    return localStorage.getItem("selected_type") || "All";
  },

  // --- get and save Currency Name ---
  saveCurrencyName(currencyName) {
    localStorage.setItem("currency_name", currencyName);
  },
  getCurrencyName() {
    return localStorage.getItem("currency_name") || "";
  },

  saveCurrencyId(currencyId) {
    localStorage.setItem("currency_id", currencyId);
  },
  getCurrencyId() {
    return (
      localStorage.getItem("currency_id") ||
      "11111111-1111-1111-1111-111111111111"
    );
  },

  // --- get and save Business Status ---
  saveBusinessStatus(status) {
    localStorage.setItem("business_status", status);
  },
  getBusinessStatus() {
    return localStorage.getItem("business_status") || "Active";
  },

  // --- get and save Designation ---
  saveDesignation(designation) {
    localStorage.setItem("designation", designation);
  },
  getDesignation() {
    return localStorage.getItem("designation") || "All";
  },

  // --- get and save Search ----
  saveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term", term);
    }
  },
  getSearch: () => localStorage.getItem("search_term") || "",
  // --- get and save Filter Seleted_warehouse ---
  saveWarehouse(warehouseId) {
    localStorage.setItem("selected_warehouse", warehouseId ?? "");
  },
  getWarehouse() {
    return localStorage.getItem("selected_warehouse") || "";
  },

  ///Sales MANAGEMENT S.O
  SIPsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  SIPgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },

  //LOCALOVERSEAS S.O
  LOOVsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  LOOVgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },
  LOOVsavePage(page, moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    localStorage.setItem(key, page ?? 1);
  },
  LOOVgetPage(moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    return parseInt(localStorage.getItem(key)) || 1;
  },
  LOOVsavePerPage(perPage, moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    localStorage.setItem(key, perPage ?? 10);
  },
  LOOVgetPerPage(moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    return parseInt(localStorage.getItem(key)) || 10;
  },
  // Flag: user explicitly cleared filters → show ALL data on remount (no date range)
  LOOVsaveAllData(tabType) {
    localStorage.setItem(`loov_show_all_${tabType}`, "1");
  },
  LOOVisAllData(tabType) {
    return localStorage.getItem(`loov_show_all_${tabType}`) === "1";
  },
  LOOVclearAllData(tabType) {
    localStorage.removeItem(`loov_show_all_${tabType}`);
  },

  //Customer S.O
  CsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  CgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },

  //PM P.O
  PMsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  PMgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },
  PMsavePage(page, moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    localStorage.setItem(key, page ?? 1);
  },
  PMgetPage(moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    return parseInt(localStorage.getItem(key)) || 1;
  },
  PMsavePerPage(perPage, moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    localStorage.setItem(key, perPage ?? 10);
  },
  PMgetPerPage(moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    return parseInt(localStorage.getItem(key)) || 10;
  },
  PMsaveFilterColumn(column, moduleKey = "") {
    const key = moduleKey ? `filter_column_${moduleKey}` : "filter_column";
    localStorage.setItem(key, column ?? "all");
  },
  PMgetFilterColumn(moduleKey = "") {
    const key = moduleKey ? `filter_column_${moduleKey}` : "filter_column";
    return localStorage.getItem(key) || "all";
  },

  //LOCALOVERSEAS P.O
  LOOVPsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  LOOVPgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },
  LOOVPsavePage(page, moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    localStorage.setItem(key, page ?? 1);
  },
  LOOVPgetPage(moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    return parseInt(localStorage.getItem(key)) || 1;
  },
  LOOVPsavePerPage(perPage, moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    localStorage.setItem(key, perPage ?? 10);
  },
  LOOVPgetPerPage(moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    return parseInt(localStorage.getItem(key)) || 10;
  },
  LOOVPsaveFilterColumn(column, moduleKey = "") {
    const key = moduleKey ? `filter_column_${moduleKey}` : "filter_column";
    localStorage.setItem(key, column ?? "all");
  },
  LOOVPgetFilterColumn(moduleKey = "") {
    const key = moduleKey ? `filter_column_${moduleKey}` : "filter_column";
    return localStorage.getItem(key) || "all";
  },

  // --- LocalOverseas Purchase: remember user chose "show all" (no date filter) ---
  LOOVPsaveAllData(tabType) {
    localStorage.setItem(`loovp_show_all_${tabType}`, "1");
  },
  LOOVPisAllData(tabType) {
    return localStorage.getItem(`loovp_show_all_${tabType}`) === "1";
  },
  LOOVPclearAllData(tabType) {
    localStorage.removeItem(`loovp_show_all_${tabType}`);
  },

  //vendors
  VsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  VgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },
  VsavePage(page, moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    localStorage.setItem(key, page ?? 1);
  },
  VgetPage(moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    return parseInt(localStorage.getItem(key)) || 1;
  },
  VsavePerPage(perPage, moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    localStorage.setItem(key, perPage ?? 10);
  },
  VgetPerPage(moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    return parseInt(localStorage.getItem(key)) || 10;
  },

  ////   Cash Account
  // BANK TRANSACTION
  BTsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_bank_transaction", term);
    }
  },
  BTgetSearch() {
    return localStorage.getItem("search_term_bank_transaction") || "";
  },

  // BANK TRANSACTION - Page / PerPage
  BTsavePage(page) {
    localStorage.setItem("page_bank_transaction", page ?? 1);
  },
  BTgetPage() {
    return parseInt(localStorage.getItem("page_bank_transaction")) || 1;
  },
  BTsavePerPage(perPage) {
    localStorage.setItem("perPage_bank_transaction", perPage ?? 10);
  },
  BTgetPerPage() {
    return parseInt(localStorage.getItem("perPage_bank_transaction")) || 10;
  },

  // Rc-outstandingcheck
  OCsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_outstanding-check", term);
    }
  },
  OCgetSearch() {
    return localStorage.getItem("search_term_outstanding-check") || "";
  },
  OCsavePage(page) {
    localStorage.setItem("page_outstanding-check", page ?? 1);
  },
  OCgetPage() {
    return parseInt(localStorage.getItem("page_outstanding-check")) || 1;
  },
  OCsavePerPage(perPage) {
    localStorage.setItem("perPage_outstanding-check", perPage ?? 10);
  },
  OCgetPerPage() {
    return parseInt(localStorage.getItem("perPage_outstanding-check")) || 10;
  },
  OCsaveFilterColumn(column) {
    localStorage.setItem("filter_column_outstanding-check", column ?? "all");
  },
  OCgetFilterColumn() {
    return localStorage.getItem("filter_column_outstanding-check") || "all";
  },

  //ISSUED CHECK
  ICsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_issued-check-account", term);
    }
  },
  ICgetSearch() {
    return localStorage.getItem("search_term_issued-check-account") || "";
  },
  ICsaveFilterColumn(column) {
    localStorage.setItem("filter_column_issued-check-account", column ?? "all");
  },
  ICgetFilterColumn() {
    return localStorage.getItem("filter_column_issued-check-account") || "all";
  },
  ICsavePage(page) {
    localStorage.setItem("page_issued-check-account", page ?? 1);
  },
  ICgetPage() {
    return parseInt(localStorage.getItem("page_issued-check-account")) || 1;
  },
  ICsavePerPage(perPage) {
    localStorage.setItem("perPage_issued-check-account", perPage ?? 10);
  },
  ICgetPerPage() {
    return parseInt(localStorage.getItem("perPage_issued-check-account")) || 10;
  },

  //ACCOUNTLIST1
  ALsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_account-list1", term);
    }
  },
  ALgetSearch() {
    return localStorage.getItem("search_term_account-list1") || "";
  },

  // ACCOUNT LIST 1 - Page / PerPage
  ALsavePage(page) {
    localStorage.setItem("page_account-list1", page ?? 1);
  },
  ALgetPage() {
    return parseInt(localStorage.getItem("page_account-list1")) || 1;
  },
  ALsavePerPage(perPage) {
    localStorage.setItem("perPage_account-list1", perPage ?? 10);
  },
  ALgetPerPage() {
    return parseInt(localStorage.getItem("perPage_account-list1")) || 10;
  },

  //ACCOUNTLIST1
  OIsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_Other_Income", term);
    }
  },
  OIgetSearch() {
    return localStorage.getItem("search_term_Other_Income") || "";
  },

  // OTHER INCOME - Page / PerPage
  OIsavePage(page) {
    localStorage.setItem("page_Other_Income", page ?? 1);
  },
  OIgetPage() {
    return parseInt(localStorage.getItem("page_Other_Income")) || 1;
  },
  OIsavePerPage(perPage) {
    localStorage.setItem("perPage_Other_Income", perPage ?? 10);
  },
  OIgetPerPage() {
    return parseInt(localStorage.getItem("perPage_Other_Income")) || 10;
  },

  //inventory
  SCTsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  SCTgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },

  // STOCK CATEGORY TAB - Page / PerPage
  SCTsavePage(page) {
    localStorage.setItem("page_stockcategorytab", page ?? 1);
  },
  SCTgetPage() {
    return parseInt(localStorage.getItem("page_stockcategorytab")) || 1;
  },
  SCTsavePerPage(perPage) {
    localStorage.setItem("perPage_stockcategorytab", perPage ?? 10);
  },
  SCTgetPerPage() {
    return parseInt(localStorage.getItem("perPage_stockcategorytab")) || 10;
  },

  PLsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  PLgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },

  // PRODUCT LIST - Page / PerPage
  PLsavePage(page) {
    localStorage.setItem("page_product-list", page ?? 1);
  },
  PLgetPage() {
    return parseInt(localStorage.getItem("page_product-list")) || 1;
  },
  PLsavePerPage(perPage) {
    localStorage.setItem("perPage_product-list", perPage ?? 10);
  },
  PLgetPerPage() {
    return parseInt(localStorage.getItem("perPage_product-list")) || 10;
  },

  //newproduction
  NPsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  NPgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },
  NPsaveFilterColumn(column) {
    localStorage.setItem("filter_column_NewProduction", column ?? "all");
  },
  NPgetFilterColumn() {
    return localStorage.getItem("filter_column_NewProduction") || "all";
  },
  NPsavePage(page) {
    localStorage.setItem("page_NewProduction", page ?? 1);
  },
  NPgetPage() {
    return parseInt(localStorage.getItem("page_NewProduction")) || 1;
  },
  NPsavePerPage(perPage) {
    localStorage.setItem("perPage_NewProduction", perPage ?? 10);
  },
  NPgetPerPage() {
    return parseInt(localStorage.getItem("perPage_NewProduction")) || 10;
  },
  //stocktransfer
  STsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  STgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },

  // STOCK TRANSFER - Page / PerPage
  STsavePage(page) {
    localStorage.setItem("page_stock_transfer", page ?? 1);
  },
  STgetPage() {
    return parseInt(localStorage.getItem("page_stock_transfer")) || 1;
  },
  STsavePerPage(perPage) {
    localStorage.setItem("perPage_stock_transfer", perPage ?? 10);
  },
  STgetPerPage() {
    return parseInt(localStorage.getItem("perPage_stock_transfer")) || 10;
  },
  STsaveTab(tab) {
    localStorage.setItem("tab_stock_transfer", tab);
  },
  STgetTab() {
    return localStorage.getItem("tab_stock_transfer") === "Approved"
      ? "Approved"
      : "Pending";
  },

  ICCAsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_inventory-accounting", term);
    }
  },
  ICCAgetSearch() {
    return localStorage.getItem("search_term_inventory-accounting") || "";
  },
  ICCAsavePage(page) {
    localStorage.setItem("page_inventoryCounting", page ?? 1);
  },
  ICCAgetPage() {
    return parseInt(localStorage.getItem("page_inventoryCounting")) || 1;
  },
  ICCAsavePerPage(perPage) {
    localStorage.setItem("perPage_inventoryCounting", perPage ?? 10);
  },
  ICCAgetPerPage() {
    return parseInt(localStorage.getItem("perPage_inventoryCounting")) || 10;
  },

  //CASHFLOW ACCOUNTING
  CFsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_Cash_flow", term);
    }
  },
  CFgetSearch() {
    return localStorage.getItem("search_term_Cash_flow") || "";
  },
  CFsaveFilterColumn(column) {
    localStorage.setItem("filter_column_Cash_flow", column ?? "All");
  },
  CFgetFilterColumn() {
    return localStorage.getItem("filter_column_Cash_flow") || "All";
  },
  CFsavePage(page) {
    localStorage.setItem("page_Cash_flow", page ?? 1);
  },
  CFgetPage() {
    return parseInt(localStorage.getItem("page_Cash_flow")) || 1;
  },
  CFsavePerPage(perPage) {
    localStorage.setItem("perPage_Cash_flow", perPage ?? 10);
  },
  CFgetPerPage() {
    return parseInt(localStorage.getItem("perPage_Cash_flow")) || 10;
  },

  PTsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  PTgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },

  LOETsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  LOETgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },
  LOETsaveFilterColumn(column, moduleKey = "") {
    const key = moduleKey ? `filter_column_${moduleKey}` : "filter_column";
    localStorage.setItem(key, column ?? "all");
  },
  LOETgetFilterColumn(moduleKey = "") {
    const key = moduleKey ? `filter_column_${moduleKey}` : "filter_column";
    return localStorage.getItem(key) || "all";
  },
  LOETsavePage(page, moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    localStorage.setItem(key, page ?? 1);
  },
  LOETgetPage(moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    return parseInt(localStorage.getItem(key)) || 1;
  },
  LOETsavePerPage(perPage, moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    localStorage.setItem(key, perPage ?? 10);
  },
  LOETgetPerPage(moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    return parseInt(localStorage.getItem(key)) || 10;
  },
  // --- LocalOverseas Expenses Tab: remember user chose "show all" (no date filter) ---
  LOETsaveAllData(tabType) {
    localStorage.setItem(`loet_show_all_${tabType}`, "1");
  },
  LOETisAllData(tabType) {
    return localStorage.getItem(`loet_show_all_${tabType}`) === "1";
  },
  LOETclearAllData(tabType) {
    localStorage.removeItem(`loet_show_all_${tabType}`);
  },
  //FIXASSET
  FAsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_FixedAsset", term);
    }
  },
  FAgetSearch() {
    return localStorage.getItem("search_term_FixedAsset") || "";
  },
  // FIXEDASSET - Page / PerPage (Depreciation / Forecast tab)
  FAsavePage(page) {
    localStorage.setItem("page_FixedAsset", page ?? 1);
  },
  FAgetPage() {
    return parseInt(localStorage.getItem("page_FixedAsset")) || 1;
  },
  FAsavePerPage(perPage) {
    localStorage.setItem("perPage_FixedAsset", perPage ?? 10);
  },
  FAgetPerPage() {
    return parseInt(localStorage.getItem("perPage_FixedAsset")) || 10;
  },
  // FIXEDASSET - Page / PerPage (Expenses / Approved tab)
  FAasavePage(page) {
    localStorage.setItem("page_FixedAsset_approved", page ?? 1);
  },
  FAagetPage() {
    return parseInt(localStorage.getItem("page_FixedAsset_approved")) || 1;
  },
  FAasavePerPage(perPage) {
    localStorage.setItem("perPage_FixedAsset_approved", perPage ?? 10);
  },
  FAagetPerPage() {
    return parseInt(localStorage.getItem("perPage_FixedAsset_approved")) || 10;
  },
  // FIXEDASSET - Page / PerPage (Masterlist tab)
  FAmsavePage(page) {
    localStorage.setItem("page_FixedAsset_masterlist", page ?? 1);
  },
  FAmgetPage() {
    return parseInt(localStorage.getItem("page_FixedAsset_masterlist")) || 1;
  },
  FAmsavePerPage(perPage) {
    localStorage.setItem("perPage_FixedAsset_masterlist", perPage ?? 10);
  },
  FAmgetPerPage() {
    return (
      parseInt(localStorage.getItem("perPage_FixedAsset_masterlist")) || 10
    );
  },
  ///ASSETACCOUNT
  AALsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_assetaccount-list1", term);
    }
  },
  AALgetSearch() {
    return localStorage.getItem("search_term_assetaccount-list1") || "";
  },
  AALsavePage(page) {
    localStorage.setItem("page_assetaccount-list1", page ?? 1);
  },
  AALgetPage() {
    return parseInt(localStorage.getItem("page_assetaccount-list1")) || 1;
  },
  AALsavePerPage(perPage) {
    localStorage.setItem("perPage_assetaccount-list1", perPage ?? 10);
  },
  AALgetPerPage() {
    return parseInt(localStorage.getItem("perPage_assetaccount-list1")) || 10;
  },
  ///LIABILITIES
  LsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_liabilities", term);
    }
  },
  LgetSearch() {
    return localStorage.getItem("search_term_liabilities") || "";
  },
  LsavePage(page) {
    localStorage.setItem("page_liabilities", page ?? 1);
  },
  LgetPage() {
    return parseInt(localStorage.getItem("page_liabilities")) || 1;
  },
  LsavePerPage(perPage) {
    localStorage.setItem("perPage_liabilities", perPage ?? 10);
  },
  LgetPerPage() {
    return parseInt(localStorage.getItem("perPage_liabilities")) || 10;
  },
  OEsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_OwnersEquity", term);
    }
  },
  OEgetSearch() {
    return localStorage.getItem("search_term_OwnersEquity") || "";
  },
  OEsavePage(page) {
    localStorage.setItem("page_OwnersEquity", page ?? 1);
  },
  OEgetPage() {
    return parseInt(localStorage.getItem("page_OwnersEquity")) || 1;
  },
  OEsavePerPage(perPage) {
    localStorage.setItem("perPage_OwnersEquity", perPage ?? 10);
  },
  OEgetPerPage() {
    return parseInt(localStorage.getItem("perPage_OwnersEquity")) || 10;
  },
  COsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_Cutoff", term);
    }
  },
  COgetSearch() {
    return localStorage.getItem("search_term_Cutoff") || "";
  },
  COsavePage(page) {
    localStorage.setItem("page_Cutoff", page ?? 1);
  },
  COgetPage() {
    return parseInt(localStorage.getItem("page_Cutoff")) || 1;
  },
  COsavePerPage(perPage) {
    localStorage.setItem("perPage_Cutoff", perPage ?? 10);
  },
  COgetPerPage() {
    return parseInt(localStorage.getItem("perPage_Cutoff")) || 10;
  },
  ///EXPENESES12
  E1saveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_expenses1", term);
    }
  },
  E1getSearch() {
    return localStorage.getItem("search_term_expenses1") || "";
  },

  // EXPENSES1 - Filter Column
  E1saveFilterColumn(column) {
    localStorage.setItem("filter_column_expenses1", column ?? "all");
  },
  E1getFilterColumn() {
    return localStorage.getItem("filter_column_expenses1") || "all";
  },

  // EXPENSES1 - Status Filter
  E1saveStatus(status) {
    localStorage.setItem("selected_status_expenses1", status);
  },
  E1getStatus() {
    return localStorage.getItem("selected_status_expenses1") || "Active";
  },

  // EXPENSES1 - Page / PerPage
  E1savePage(page) {
    localStorage.setItem("page_expenses1", page ?? 1);
  },
  E1getPage() {
    const raw = localStorage.getItem("page_expenses1");
    if (raw === null) return null;
    return parseInt(raw) || 1;
  },
  E1savePerPage(perPage) {
    localStorage.setItem("perPage_expenses1", perPage ?? 10);
  },
  E1getPerPage() {
    return parseInt(localStorage.getItem("perPage_expenses1")) || 10;
  },

  E2saveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_expenses2", term);
    }
  },
  E2getSearch() {
    return localStorage.getItem("search_term_expenses2") || "";
  },

  // EXPENSES2 - Filter Column
  E2saveFilterColumn(column) {
    localStorage.setItem("filter_column_expenses2", column ?? "all");
  },
  E2getFilterColumn() {
    return localStorage.getItem("filter_column_expenses2") || "all";
  },

  // EXPENSES2 - Status Filter
  E2saveStatus(status) {
    localStorage.setItem("selected_status_expenses2", status);
  },
  E2getStatus() {
    return localStorage.getItem("selected_status_expenses2") || "Active";
  },

  // EXPENSES2 - Page / PerPage
  E2savePage(page) {
    localStorage.setItem("page_expenses2", page ?? 1);
  },
  E2getPage() {
    return parseInt(localStorage.getItem("page_expenses2")) || 1;
  },
  E2savePerPage(perPage) {
    localStorage.setItem("perPage_expenses2", perPage ?? 10);
  },
  E2getPerPage() {
    return parseInt(localStorage.getItem("perPage_expenses2")) || 10;
  },

  ACsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_Access_control", term);
    }
  },
  ACgetSearch() {
    return localStorage.getItem("search_term_Access_control") || "";
  },
  ACsavePage(page) {
    localStorage.setItem("page_Access_control", page ?? 1);
  },
  ACgetPage() {
    return parseInt(localStorage.getItem("page_Access_control")) || 1;
  },
  ACsavePerPage(perPage) {
    localStorage.setItem("perPage_Access_control", perPage ?? 10);
  },
  ACgetPerPage() {
    return parseInt(localStorage.getItem("perPage_Access_control")) || 10;
  },
  BsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_Branches", term);
    }
  },
  BgetSearch() {
    return localStorage.getItem("search_term_Branches") || "";
  },
  BsavePage(page) {
    localStorage.setItem("page_Branches", page ?? 1);
  },
  BgetPage() {
    return parseInt(localStorage.getItem("page_Branches")) || 1;
  },
  BsavePerPage(perPage) {
    localStorage.setItem("perPage_Branches", perPage ?? 10);
  },
  BgetPerPage() {
    return parseInt(localStorage.getItem("perPage_Branches")) || 10;
  },
  UMsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_UserManagement", term);
    }
  },
  UMgetSearch() {
    return localStorage.getItem("search_term_UserManagement") || "";
  },
  UMsavePage(page) {
    localStorage.setItem("page_UserManagement", page ?? 1);
  },
  UMgetPage() {
    return parseInt(localStorage.getItem("page_UserManagement")) || 1;
  },
  UMsavePerPage(perPage) {
    localStorage.setItem("perPage_UserManagement", perPage ?? 10);
  },
  UMgetPerPage() {
    return parseInt(localStorage.getItem("perPage_UserManagement")) || 10;
  },
  CurrsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_Currency", term);
    }
  },
  CurrgetSearch() {
    return localStorage.getItem("search_term_Currency") || "";
  },

  // CURRENCY - Filter Column
  CurrsaveFilterColumn(column) {
    localStorage.setItem("filter_column_Currency", column ?? "all");
  },
  CurrgetFilterColumn() {
    return localStorage.getItem("filter_column_Currency") || "all";
  },

  // CURRENCY - Status Filter
  CurrsaveStatus(status) {
    localStorage.setItem("selected_status_Currency", status);
  },
  CurrgetStatus() {
    return localStorage.getItem("selected_status_Currency") || "All";
  },

  // CURRENCY - Page / PerPage
  CurrsavePage(page) {
    localStorage.setItem("page_Currency", page ?? 1);
  },
  CurrgetPage() {
    return parseInt(localStorage.getItem("page_Currency")) || 1;
  },
  CurrsavePerPage(perPage) {
    localStorage.setItem("perPage_Currency", perPage ?? 10);
  },
  CurrgetPerPage() {
    return parseInt(localStorage.getItem("perPage_Currency")) || 10;
  },
  ALOGsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_ActivityLog", term);
    }
  },
  ALOGgetSearch() {
    return localStorage.getItem("search_term_ActivityLog") || "";
  },
  ALOGsavePage(page) {
    localStorage.setItem("page_ActivityLog", page ?? 1);
  },
  ALOGgetPage() {
    return parseInt(localStorage.getItem("page_ActivityLog")) || 1;
  },
  ALOGsavePerPage(perPage) {
    localStorage.setItem("perPage_ActivityLog", perPage ?? 10);
  },
  ALOGgetPerPage() {
    return parseInt(localStorage.getItem("perPage_ActivityLog")) || 10;
  },
  AuditLOGgetPerPage() {
    return parseInt(localStorage.getItem("perPage_AuditLog")) || 10;
  },

  // TAX SETTINGS - Search
  TSsaveSearch(term) {
    if (term !== undefined && term !== null) {
      localStorage.setItem("search_term_tax_settings", term);
    }
  },
  TSgetSearch() {
    return localStorage.getItem("search_term_tax_settings") || "";
  },

  // TAX SETTINGS - Filter Column
  TSsaveFilterColumn(column) {
    localStorage.setItem("filter_column_tax_settings", column ?? "all");
  },
  TSgetFilterColumn() {
    return localStorage.getItem("filter_column_tax_settings") || "all";
  },

  // TAX SETTINGS - Page / PerPage
  TSsavePage(page) {
    localStorage.setItem("page_tax_settings", page ?? 1);
  },
  TSgetPage() {
    return parseInt(localStorage.getItem("page_tax_settings")) || 1;
  },
  TSsavePerPage(perPage) {
    localStorage.setItem("perPage_tax_settings", perPage ?? 10);
  },
  TSgetPerPage() {
    return parseInt(localStorage.getItem("perPage_tax_settings")) || 10;
  },

  // --- get and save Filter Column ---
  saveFilterColumn(column) {
    localStorage.setItem("filter_column", column ?? "all");
  },
  getFilterColumn() {
    return localStorage.getItem("filter_column") || "all";
  },

  // --- get and save Product Category ---
  saveProductCategory(category) {
    localStorage.setItem("product_selected_category", JSON.stringify(category));
  },
  getProductCategory() {
    try {
      const saved = localStorage.getItem("product_selected_category");
      const parsed = saved ? JSON.parse(saved) : null;
      return Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  },

  // --- get and save Account Filter ---
  saveAccountFilter(account) {
    localStorage.setItem("account_filter", JSON.stringify(account ?? ""));
  },
  getAccountFilter() {
    try {
      const saved = localStorage.getItem("account_filter");
      return saved ? JSON.parse(saved) : "";
    } catch {
      return "";
    }
  },

  // --- get and save Branch Status ---
  saveBranchStatus(status) {
    localStorage.setItem("branch_status_filter", status);
  },
  getBranchStatus() {
    return localStorage.getItem("branch_status_filter") || "All";
  },

  // --- get and save Subject 2 ---
  saveSubject2(subjectId) {
    localStorage.setItem("selected_subject2", subjectId ?? "");
  },
  getSubject2() {
    return localStorage.getItem("selected_subject2") || null;
  },

  // --- get and save User Type ---
  saveUserType(userType) {
    localStorage.setItem("selected_user_type", userType);
  },
  getUserType() {
    return localStorage.getItem("selected_user_type") || "All";
  },

  // INVOICE - Pending Tab
  NIsaveSearch(term, moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    if (term !== undefined && term !== null) {
      localStorage.setItem(key, term);
    }
  },
  NIgetSearch(moduleKey = "") {
    const key = moduleKey ? `search_term_${moduleKey}` : "search_term";
    return localStorage.getItem(key) || "";
  },
  NIsaveFilterColumn(column, moduleKey = "") {
    const key = moduleKey ? `filter_column_${moduleKey}` : "filter_column";
    localStorage.setItem(key, column ?? "all");
  },
  NIgetFilterColumn(moduleKey = "") {
    const key = moduleKey ? `filter_column_${moduleKey}` : "filter_column";
    return localStorage.getItem(key) || "all";
  },
  NIsavePage(page, moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    localStorage.setItem(key, page ?? 1);
  },
  NIgetPage(moduleKey = "") {
    const key = moduleKey ? `page_${moduleKey}` : "page";
    return parseInt(localStorage.getItem(key)) || 1;
  },
  NIsavePerPage(perPage, moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    localStorage.setItem(key, perPage ?? 10);
  },
  NIgetPerPage(moduleKey = "") {
    const key = moduleKey ? `perPage_${moduleKey}` : "perPage";
    return parseInt(localStorage.getItem(key)) || 10;
  },

  // --- Invoice: remember that user chose "show all data" (no date filter) ---
  NIsaveAllData() {
    localStorage.setItem("NI_show_all", "1");
  },
  NIisAllData() {
    return localStorage.getItem("NI_show_all") === "1";
  },
  NIclearAllData() {
    localStorage.removeItem("NI_show_all");
  },

  // --- Payable: remember that user chose "show all data" (no date filter) ---
  PAsaveAllData() {
    localStorage.setItem("PA_show_all", "1");
  },
  PAisAllData() {
    return localStorage.getItem("PA_show_all") === "1";
  },
  PAclearAllData() {
    localStorage.removeItem("PA_show_all");
  },

  // --- Expenses: remember that user chose "show all data" (no date filter) ---
  EXsaveAllData() {
    localStorage.setItem("EX_show_all", "1");
  },
  EXisAllData() {
    return localStorage.getItem("EX_show_all") === "1";
  },
  EXclearAllData() {
    localStorage.removeItem("EX_show_all");
  },

  // --- to clear the saved filter ----
  clear() {
    localStorage.removeItem("filter_from");
    localStorage.removeItem("filter_to");
    localStorage.removeItem("filter_from_accountlist1");
    localStorage.removeItem("filter_to_accountlist1");
    localStorage.removeItem("Selected_id");
    localStorage.removeItem("search_term");
    localStorage.removeItem("search_term_bank_transaction"); // ← add this
    localStorage.removeItem("page_bank_transaction");
    localStorage.removeItem("perPage_bank_transaction");
    localStorage.removeItem("search_term_outstanding-check");
    localStorage.removeItem("page_outstanding-check");
    localStorage.removeItem("perPage_outstanding-check");
    localStorage.removeItem("filter_column_outstanding-check");
    localStorage.removeItem("search_term_issued-check-account");
    localStorage.removeItem("filter_column_issued-check-account");
    localStorage.removeItem("page_issued-check-account");
    localStorage.removeItem("perPage_issued-check-account");
    localStorage.removeItem("search_term_account-list1");
    localStorage.removeItem("page_account-list1");
    localStorage.removeItem("perPage_account-list1");
    localStorage.removeItem("search_term_Other_Income");
    localStorage.removeItem("page_Other_Income");
    localStorage.removeItem("perPage_Other_Income");
    localStorage.removeItem("search_term_inventory-accounting");
    localStorage.removeItem("page_inventoryCounting");
    localStorage.removeItem("perPage_inventoryCounting");
    localStorage.removeItem("search_term_Cash_flow");
    localStorage.removeItem("filter_column_Cash_flow");
    localStorage.removeItem("page_Cash_flow");
    localStorage.removeItem("perPage_Cash_flow");
    localStorage.removeItem("search_term_FixedAsset");
    localStorage.removeItem("page_FixedAsset");
    localStorage.removeItem("perPage_FixedAsset");
    localStorage.removeItem("page_FixedAsset_approved");
    localStorage.removeItem("perPage_FixedAsset_approved");
    localStorage.removeItem("search_term_assetaccount-list1");
    localStorage.removeItem("page_assetaccount-list1");
    localStorage.removeItem("perPage_assetaccount-list1");
    localStorage.removeItem("search_term_liabilities");
    localStorage.removeItem("page_liabilities");
    localStorage.removeItem("perPage_liabilities");
    localStorage.removeItem("search_term_OwnersEquity");
    localStorage.removeItem("page_OwnersEquity");
    localStorage.removeItem("perPage_OwnersEquity");
    localStorage.removeItem("search_term_Cutoff");
    localStorage.removeItem("page_Cutoff");
    localStorage.removeItem("perPage_Cutoff");
    localStorage.removeItem("search_term_tax_settings");
    localStorage.removeItem("filter_column_tax_settings");
    localStorage.removeItem("page_tax_settings");
    localStorage.removeItem("perPage_tax_settings");
    localStorage.removeItem("search_term_expenses1");
    localStorage.removeItem("filter_column_expenses1");
    localStorage.removeItem("selected_status_expenses1");
    localStorage.removeItem("page_expenses1");
    localStorage.removeItem("perPage_expenses1");
    localStorage.removeItem("search_term_expenses2");
    localStorage.removeItem("filter_column_expenses2");
    localStorage.removeItem("selected_status_expenses2");
    localStorage.removeItem("page_expenses2");
    localStorage.removeItem("perPage_expenses2");
    localStorage.removeItem("search_term_Access_control");
    localStorage.removeItem("page_Access_control");
    localStorage.removeItem("perPage_Access_control");
    localStorage.removeItem("search_term_Branches");
    localStorage.removeItem("page_Branches");
    localStorage.removeItem("perPage_Branches");
    localStorage.removeItem("search_term_UserManagement");
    localStorage.removeItem("page_UserManagement");
    localStorage.removeItem("perPage_UserManagement");
    localStorage.removeItem("search_term_Currency");
    localStorage.removeItem("filter_column_Currency");
    localStorage.removeItem("selected_status_Currency");
    localStorage.removeItem("page_Currency");
    localStorage.removeItem("perPage_Currency");
    localStorage.removeItem("search_term_ActivityLog");
    localStorage.removeItem("page_ActivityLog");
    localStorage.removeItem("perPage_ActivityLog");
    localStorage.removeItem("page_stock_transfer");
    localStorage.removeItem("perPage_stock_transfer");
    localStorage.removeItem("search_term_NewProduction");
    localStorage.removeItem("filter_column_NewProduction");
    localStorage.removeItem("page_NewProduction");
    localStorage.removeItem("perPage_NewProduction");
    localStorage.removeItem("search_term_stockcategorytab");
    localStorage.removeItem("page_stockcategorytab");
    localStorage.removeItem("perPage_stockcategorytab");
    localStorage.removeItem("search_term_product-list");
    localStorage.removeItem("page_product-list");
    localStorage.removeItem("perPage_product-list");
    localStorage.removeItem("search_term_vendors");
    localStorage.removeItem("page_vendors");
    localStorage.removeItem("perPage_vendors");
    localStorage.removeItem("search_term_customer");
    localStorage.removeItem("page_customer");
    localStorage.removeItem("perPage_customer");
    localStorage.removeItem("search_term_invoice_pending");
    localStorage.removeItem("filter_column_invoice_pending");
    localStorage.removeItem("page_invoice_pending");
    localStorage.removeItem("perPage_invoice_pending");
    localStorage.removeItem("search_term_invoice_approved");
    localStorage.removeItem("filter_column_invoice_approved");
    localStorage.removeItem("page_invoice_approved");
    localStorage.removeItem("perPage_invoice_approved");
    localStorage.removeItem("search_term_loov_local_collection");
    localStorage.removeItem("page_loov_local_collection");
    localStorage.removeItem("perPage_loov_local_collection");
    localStorage.removeItem("loov_show_all_local");
    localStorage.removeItem("search_term_loov_overseas_collection");
    localStorage.removeItem("page_loov_overseas_collection");
    localStorage.removeItem("perPage_loov_overseas_collection");
    localStorage.removeItem("loov_show_all_overseas");
    localStorage.removeItem("search_term_loov_local_transaction_list");
    localStorage.removeItem("page_loov_local_transaction_list");
    localStorage.removeItem("perPage_loov_local_transaction_list");
    localStorage.removeItem("perPage_loov_local_transaction_details");
    localStorage.removeItem("search_term_loov_overseas_transaction_list");
    localStorage.removeItem("page_loov_overseas_transaction_list");
    localStorage.removeItem("perPage_loov_overseas_transaction_list");
    localStorage.removeItem("perPage_loov_overseas_transaction_details");
    localStorage.removeItem("search_term_local_accountings");
    localStorage.removeItem("filter_column_local_accountings");
    localStorage.removeItem("page_local_accountings");
    localStorage.removeItem("perPage_local_accountings");
    localStorage.removeItem("search_term_overseas_accountings");
    localStorage.removeItem("filter_column_overseas_accountings");
    localStorage.removeItem("page_overseas_accountings");
    localStorage.removeItem("perPage_overseas_accountings");
    localStorage.removeItem("loet_show_all_local");
    localStorage.removeItem("loet_show_all_overseas");
    localStorage.removeItem("search_term_local_accountings_transaction_list");
    localStorage.removeItem("page_local_accountings_transaction_list");
    localStorage.removeItem("perPage_local_accountings_transaction_list");
    localStorage.removeItem(
      "search_term_overseas_accountings_transaction_list",
    );
    localStorage.removeItem("page_overseas_accountings_transaction_list");
    localStorage.removeItem("perPage_overseas_accountings_transaction_list");
    localStorage.removeItem("search_term_payable");
    localStorage.removeItem("page_payable_pending");
    localStorage.removeItem("perPage_payable_pending");
    localStorage.removeItem("filter_column_payable_pending");
    localStorage.removeItem("page_payable_approved");
    localStorage.removeItem("perPage_payable_approved");
    localStorage.removeItem("filter_column_payable_approved");
    localStorage.removeItem("NI_show_all");
    localStorage.removeItem("PA_show_all");
    localStorage.removeItem("EX_show_all");
    localStorage.removeItem("search_term_local_purchase");
    localStorage.removeItem("page_local_purchase");
    localStorage.removeItem("perPage_local_purchase");
    localStorage.removeItem("filter_column_local_purchase");
    localStorage.removeItem("loovp_show_all_local");
    localStorage.removeItem("search_term_overseas_purchase");
    localStorage.removeItem("page_overseas_purchase");
    localStorage.removeItem("perPage_overseas_purchase");
    localStorage.removeItem("filter_column_overseas_purchase");
    localStorage.removeItem("loovp_show_all_overseas");
    localStorage.removeItem("search_term_local_purchase_transaction_list");
    localStorage.removeItem("page_local_purchase_transaction_list");
    localStorage.removeItem("perPage_local_purchase_transaction_list");
    localStorage.removeItem("perPage_local_purchase_transaction_details");
    localStorage.removeItem("search_term_overseas_purchase_transaction_list");
    localStorage.removeItem("page_overseas_purchase_transaction_list");
    localStorage.removeItem("perPage_overseas_purchase_transaction_list");
    localStorage.removeItem("perPage_overseas_purchase_transaction_details");
  },
};

console.log("hello filterstore" + FilterStore);

// Inactivity reset: runs as soon as this file is first imported (before any
// page reads its saved filters), so a user returning after 24+ hours starts
// with fresh filters.
FilterStore.clearIfInactive();
FilterStore.touchActivity();

let lastActivityWrite = Date.now();
const handleUserActivity = () => {
  const now = Date.now();
  if (now - lastActivityWrite < 60 * 1000) return;
  lastActivityWrite = now;
  FilterStore.clearIfInactive();
  FilterStore.touchActivity();
};
["mousedown", "keydown", "touchstart", "visibilitychange"].forEach((event) =>
  window.addEventListener(event, handleUserActivity, { passive: true }),
);

export default FilterStore;
